import React from 'react';
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { RadioInput } from 'components/form';
import styles from './styles.module.scss';
import { QUESTION_CARD, QUESTION_TITLE, QUESTION_SUBTITLE } from '../card-classes';

interface Option {
  label: string;
  value: string;
}

interface QuestionRankingProps {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  errors: any;
  name: string;
  options: Option[];
  questionText: string;
  questionNumber: number;
  statement: string;
  labelText: string;
  containerClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  statementContainerClassName?: string;
  statementTextClassName?: string;
  rankGroupClassName?: string;
  mostLikelyLabelClassName?: string;
  leastLikelyLabelClassName?: string;
  radioContainerClassName?: string;
  minLabel?: string;
  maxLabel?: string;
}

export const QuestionRanking: React.FC<QuestionRankingProps> = ({
  register,
  watch,
  setValue,
  errors,
  name,
  options,
  questionText,
  questionNumber,
  statement,
  labelText,
  containerClassName,
  titleClassName,
  subtitleClassName,
  statementContainerClassName,
  statementTextClassName,
  rankGroupClassName,
  mostLikelyLabelClassName,
  leastLikelyLabelClassName,
  radioContainerClassName,
  minLabel,
  maxLabel,
}) => {
  const selectedValue = watch(name);
  const currentValue = Array.isArray(selectedValue) ? selectedValue[0] : selectedValue || '';
  const resolvedMinLabel = minLabel || 'Least Likely';
  const resolvedMaxLabel = maxLabel || 'Most Likely';
  const labelsAreLong = resolvedMinLabel.length > 32 || resolvedMaxLabel.length > 32 || (resolvedMinLabel.length + resolvedMaxLabel.length) > 56;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clickedValue = e.target.value;
    if (clickedValue === currentValue) {
      setValue(name, '', { shouldValidate: true });
    } else {
      setValue(name, clickedValue, { shouldValidate: true });
    }
  };

  return (
    <div className={`${QUESTION_CARD} ${containerClassName || ''}`}>
      <h3 className={`${QUESTION_TITLE} ${titleClassName || ''}`}>
        {questionNumber}. {questionText}
      </h3>
      <p className={`${QUESTION_SUBTITLE} ${subtitleClassName || ''}`}>
        {labelText}
      </p>
      <div className={`${styles.statementContainer} ${statementContainerClassName || ''}`}>
        <p className={`${styles.statementText} ${statementTextClassName || ''}`}>
          {statement}
        </p>
        <div className={`${styles.rankGroup} ${rankGroupClassName || ''}`}>
          <span className={`${styles.scaleLabel} ${styles.minLabel} ${labelsAreLong ? styles.compactScaleLabel : ''} ${leastLikelyLabelClassName || ''}`}>{resolvedMinLabel}</span>
          <RadioInput
            register={register}
            name={name}
            options={options}
            type="checkbox"
            parentClassName={`${styles.rankingOptionsContainer} ${radioContainerClassName || ''}`}
            validatorMessage={errors?.[name]?.message}
            checkValue={currentValue ? [currentValue] : []}
            onChange={handleChange}
          />
          <span className={`${styles.scaleLabel} ${styles.maxLabel} ${labelsAreLong ? styles.compactScaleLabel : ''} ${mostLikelyLabelClassName || ''}`}>{resolvedMaxLabel}</span>
        </div>
      </div>
    </div>
  );
};
